import { render, staticRenderFns } from "./OrganDetail.vue?vue&type=template&id=292c1c28&scoped=true"
import script from "./OrganDetail.vue?vue&type=script&lang=js"
export * from "./OrganDetail.vue?vue&type=script&lang=js"
import style0 from "./OrganDetail.vue?vue&type=style&index=0&id=292c1c28&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292c1c28",
  null
  
)

export default component.exports